import { useCallback, useEffect, useState } from 'react';
import {
  TIME_PER_DAY,
  TIME_PER_HOUR,
  TIME_PER_MINUTE,
  TIME_PER_MONTH,
} from '../constants/time';

const useHandleTime = ({ dueDate }: { dueDate: string }) => {
  const [remainingTime, setRemainingTime] = useState('');
  const [timeValues, setTimeValues] = useState({
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const calculateTimeRemaining = useCallback(() => {
    const now = new Date();
    const timeDiff = new Date(dueDate).getTime() - now.getTime();

    if (timeDiff <= 0) {
      setRemainingTime('0m 0s');
      setTimeValues({
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
      return;
    }

    const months = Math.floor(timeDiff / TIME_PER_MONTH);
    const days = Math.floor((timeDiff % TIME_PER_MONTH) / TIME_PER_DAY);
    const hours = Math.floor((timeDiff % TIME_PER_DAY) / TIME_PER_HOUR);
    const minutes = Math.floor((timeDiff % TIME_PER_HOUR) / TIME_PER_MINUTE);

    let timeString = '';
    if (months > 0) timeString += `${months}m `;
    if (days > 0) timeString += `${days}d `;
    if (hours > 0) timeString += `${hours}h `;
    if (minutes > 0) timeString += `${minutes}m`;

    setRemainingTime(timeString.trim());
    setTimeValues({
      months,
      days,
      hours,
      minutes,
      seconds: 0,
    });
  }, [dueDate]);

  useEffect(() => {
    calculateTimeRemaining();
    const interval = setInterval(calculateTimeRemaining, 60000);

    return () => clearInterval(interval);
  }, [calculateTimeRemaining, dueDate]);

  return { remainingTime, timeValues };
};

export default useHandleTime;
